/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceCaseImage } from './DeviceCaseImage';
export type ListedCase = {
    caseId: string;
    status: ListedCase.status;
    imei?: string;
    serial?: string;
    model?: string;
    os?: ListedCase.os;
    images: Array<DeviceCaseImage>;
    createdAt: string;
    updatedAt: string;
};
export namespace ListedCase {
    export enum status {
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        ARCHIVED = 'ARCHIVED',
        REJECTED = 'REJECTED',
        CLOSED = 'CLOSED',
    }
    export enum os {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
    }
}

